const PlayerReducer = (state = { playedSeconds: 0 }, action) => {
  switch (action.type) {
    case 'START':
      return { ...state, playing: true };
    case 'PLAYING':
      return { ...state, playedSeconds: action.playedSeconds };
    case 'PAUSE':
      return { ...state, playing: false };
    case 'STOP':
      return { ...state, playing: false };
    case 'SEEK':
      return { ...state, seekTo: action.seekTo };
    case 'SEEKED':
      return { ...state, seekTo: undefined };
    default:
      return state;
  }
};

export default PlayerReducer;
